import { render, staticRenderFns } from "./ClaimVerify.vue?vue&type=template&id=267cf2f3"
import script from "./ClaimVerify.vue?vue&type=script&lang=ts"
export * from "./ClaimVerify.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports